import api from "../../services/usersAndGroups"
import axios from "axios";
import { Notification } from 'element-ui';
import {EventBus} from "../../eventBus"

const state = {
    allUserGroups: [],
    allUserGroupsSettings: [],
    allStoreLists: [],
    allFilters: {
        department: [],
        functions: [],
        designations: [],
        users: []
    },
    all_functions: [],
    get_user_groups_loading: false,
    get_filters_loading: false,
    get_user_groups_settings_loading: false,
    head_office_id: ''
};

const mutations = {
    SET_USER_GROUPS(state, data) {
        state.allUserGroups = data;
    },
    SET_FUNCTIONS_LIST(state, data) {
        state.all_functions = data;
    },
    HANDLE_USER_GROUPS_LOADING(state, condition) {
        state.get_user_groups_loading = condition
    },
    SET_USER_GROUPS_SETTINGS(state, data) {
        state.allUserGroupsSettings = data;
    },
    HANDLE_USER_GROUPS_SETTINGS_LOADING(state, condition) {
        state.get_user_groups_settings_loading = condition
    },
    SET_FILTERS(state, data) {
        state.allFilters = data;
    },
    HANDLE_FILTERS_LOADING(state, condition) {
        state.get_filters_loading = condition
    },
    SET_ALL_STORE_LIST(state, data) {
        let f = data.find((e) => e.type === 'head_office');
        state.head_office_id = f.id;
        state.allStoreLists = data
    },
};

const actions = {
    getUserGroupsAction({ commit, dispatch }, payload) {
        commit('HANDLE_USER_GROUPS_LOADING', true);
        api.getUserGroups(payload).then((res) => {
            if (res.status == 200) {
                const data = JSON.parse(res.data);
                commit('SET_USER_GROUPS', data);
                commit('HANDLE_USER_GROUPS_LOADING', false);
            }
        }).catch((err) => {
            console.error(err);
            commit('HANDLE_USER_GROUPS_LOADING', false);
        });
    },
    async getFunctionsAction({ commit, dispatch }, payload) {
        // Set store first
        await api.getAllStoreData().then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_ALL_STORE_LIST', result);
            // Set head office id
        }).catch((err) => {
            console.error(err)
        });
        // Then call functions api
        api.getFunctions({ outlet_id: state.head_office_id }).then((res) => {
            if (res.status == 200) {
                const data = JSON.parse(res.data);
                commit('SET_FUNCTIONS_LIST', data);
            }
        }).catch((err) => {
            console.error(err);
        });
    },
    deleteGroupAction({ commit, dispatch }, payload) {
        commit('HANDLE_USER_GROUPS_LOADING', true);
        api.deleteGroup(payload).then((res) => {
            commit('HANDLE_USER_GROUPS_LOADING', false);
            dispatch('getUserGroupsAction', {store_id: null});
            Notification.success({
                title: 'Success',
                message: 'User group deleted successfully'
            });
        }).catch((err) => {
            console.error(err);
            commit('HANDLE_USER_GROUPS_LOADING', false);
        });
    },
    getUserGroupsSettingsAction({ commit, dispatch }) {
        let payload = { store_id: null };
        commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', true);
        api.getUserGroupsSettings(payload).then((res) => {
            if (res.status == 200) {
                const data = JSON.parse(res.data);
                commit('SET_USER_GROUPS_SETTINGS', data);
                commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', false);
            }
        }).catch((err) => {
            console.error(err);
            commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', false);
        });
    },
    updateGroupsGuidelineAction({ commit, dispatch }, payload) {
        commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', true);
        api.createUpdateUserGroupSettings(payload).then((res) => {
            dispatch("getUserGroupsSettingsAction")
            Notification.success({
                title: 'Success',
                message: 'Guidelines updated successfully'
            });
            EventBus.$emit('clearNewRoleEditTab');
            commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', false);
        }).catch((err) => {
            console.error(err);
            // if()
            Notification.error({
                title: 'Error',
                message: 'Group is already defined'
            });
            commit('HANDLE_USER_GROUPS_SETTINGS_LOADING', false);
        });
    },
    async getAllFiltersAction({ commit, dispatch }) {
        commit('HANDLE_FILTERS_LOADING', true);
        // Get all store list first
        let head_office_id = '';
        await api.getAllStoreData().then((res) => {
            let result = JSON.parse(res.data);
            commit('SET_ALL_STORE_LIST', result);
            // Set head office id
            let f = result.find((e) => e.type === 'head_office');
            head_office_id = f.id;
        }).catch((err) => {
            console.error(err)
        });
        // Let prepare payload
        let payload = {
            dept: { outlet_id: head_office_id },
            function: { outlet_id: head_office_id },
            deg: { store: head_office_id },
            users: { outlet_id: head_office_id }
        };
        // Now we can call all api`s
        api.getAllFilters(payload).then(axios.spread((
            getDepartment,
            getFunction,
            getDesignations,
            getUsers
        ) => {
            if (
                getDepartment.status == 200 &&
                getFunction.status == 200 &&
                getDesignations.status == 200 &&
                getUsers.status == 200
            ) {
                let obj = { department: [], functions: [], designations: [], users: [] }
                obj.department = JSON.parse(getDepartment.data);
                obj.functions = JSON.parse(getFunction.data);
                obj.designations = JSON.parse(getDesignations.data);
                obj.users = JSON.parse(getUsers.data);
                commit('SET_FILTERS', obj);
                commit('HANDLE_FILTERS_LOADING', false);
            }
        })).catch((err) => {
            console.error(err);
            commit('HANDLE_FILTERS_LOADING', false);
        });
    },
};

const getters = {
    getGroupName: (state) => (group_id) => {
        const group = state.allUserGroups.find((group) => group.id === group_id);
        return group ? group.name : '';
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};
